{
	"achievements": {
		"Beginner": {
			"threshold": 50,
			"earned": false,
			"messageKey": "achievements.beginner"
		},
		"CarrotSnatcher": {
			"threshold": 100,
			"earned": false,
			"messageKey": "achievements.carrotSnatcher"
		},
		"BunnyBerserker": {
			"threshold": 200,
			"earned": false,
			"messageKey": "achievements.bunnyBerserker"
		},
		"HopPunk": {
			"threshold": 300,
			"earned": false,
			"messageKey": "achievements.hopPunk"
		},
		"BunnyNinja": {
			"threshold": 400,
			"earned": false,
			"messageKey": "achievements.bunnyNinja"
		},
		"Expert": {
			"threshold": 500,
			"earned": false,
			"messageKey": "achievements.expert"
		},
		"Master": {
			"threshold": 1000,
			"earned": false,
			"messageKey": "achievements.master"
		},
		"Carrotpocalypse": {
			"threshold": 2000,
			"earned": false,
			"messageKey": "achievements.carrotpocalypse"
		},
		"BunnyOverlord": {
			"threshold": 3000,
			"earned": false,
			"messageKey": "achievements.bunnyOverlord"
		},
		"ChaosHare": {
			"threshold": 4000,
			"earned": false,
			"messageKey": "achievements.chaosHare"
		},
		"CarrotCultist": {
			"threshold": 5000,
			"earned": false,
			"messageKey": "achievements.carrotCultist"
		},
		"BunnyberryPie": {
			"threshold": 6000,
			"earned": false,
			"messageKey": "achievements.bunnyberryPie"
		},
		"RabbitHole": {
			"threshold": 7000,
			"earned": false,
			"messageKey": "achievements.rabbitHole"
		},
		"MoonRabbit": {
			"threshold": 8000,
			"earned": false,
			"messageKey": "achievements.moonRabbit"
		},
		"BunnyDoom": {
			"threshold": 9000,
			"earned": false,
			"messageKey": "achievements.bunnyDoom"
		},
		"CarrotNuke": {
			"threshold": 10000,
			"earned": false,
			"messageKey": "achievements.carrotNuke"
		},
		"BunnyMatrix": {
			"threshold": 15000,
			"earned": false,
			"messageKey": "achievements.bunnyMatrix"
		},
		"CosmicHare": {
			"threshold": 25000,
			"earned": false,
			"messageKey": "achievements.cosmicHare"
		},
		"WarrenSingularity": {
			"threshold": 42000,
			"earned": false,
			"messageKey": "achievements.warrenSingularity"
		},
		"EternalBunny": {
			"threshold": 50000,
			"earned": false,
			"messageKey": "achievements.eternalBunny"
		}
	}
}
